/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DateValueValidationModel } from './DateValueValidationModel';
import {
    DateValueValidationModelFromJSON,
    DateValueValidationModelFromJSONTyped,
    DateValueValidationModelToJSON,
} from './DateValueValidationModel';
import type { DecimalValueValidationModel } from './DecimalValueValidationModel';
import {
    DecimalValueValidationModelFromJSON,
    DecimalValueValidationModelFromJSONTyped,
    DecimalValueValidationModelToJSON,
} from './DecimalValueValidationModel';
import type { IntegerValueValidationModel } from './IntegerValueValidationModel';
import {
    IntegerValueValidationModelFromJSON,
    IntegerValueValidationModelFromJSONTyped,
    IntegerValueValidationModelToJSON,
} from './IntegerValueValidationModel';
import type { SelectionValueValidationModel } from './SelectionValueValidationModel';
import {
    SelectionValueValidationModelFromJSON,
    SelectionValueValidationModelFromJSONTyped,
    SelectionValueValidationModelToJSON,
} from './SelectionValueValidationModel';

/**
 * Configures the client-side validation for the FormField.
 * @export
 * @interface FormFieldValidationModel
 */
export interface FormFieldValidationModel {
    /**
     * 
     * @type {string}
     * @memberof FormFieldValidationModel
     */
    errorMessage: string;
    /**
     * 
     * @type {SelectionValueValidationModel}
     * @memberof FormFieldValidationModel
     */
    selection?: SelectionValueValidationModel;
    /**
     * 
     * @type {IntegerValueValidationModel}
     * @memberof FormFieldValidationModel
     */
    length?: IntegerValueValidationModel;
    /**
     * 
     * @type {DecimalValueValidationModel}
     * @memberof FormFieldValidationModel
     */
    value?: DecimalValueValidationModel;
    /**
     * 
     * @type {DateValueValidationModel}
     * @memberof FormFieldValidationModel
     */
    date?: DateValueValidationModel;
}

/**
 * Check if a given object implements the FormFieldValidationModel interface.
 */
export function instanceOfFormFieldValidationModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "errorMessage" in value;

    return isInstance;
}

export function FormFieldValidationModelFromJSON(json: any): FormFieldValidationModel {
    return FormFieldValidationModelFromJSONTyped(json, false);
}

export function FormFieldValidationModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormFieldValidationModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'errorMessage': json['errorMessage'],
        'selection': !exists(json, 'selection') ? undefined : SelectionValueValidationModelFromJSON(json['selection']),
        'length': !exists(json, 'length') ? undefined : IntegerValueValidationModelFromJSON(json['length']),
        'value': !exists(json, 'value') ? undefined : DecimalValueValidationModelFromJSON(json['value']),
        'date': !exists(json, 'date') ? undefined : DateValueValidationModelFromJSON(json['date']),
    };
}

export function FormFieldValidationModelToJSON(value?: FormFieldValidationModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'errorMessage': value.errorMessage,
        'selection': SelectionValueValidationModelToJSON(value.selection),
        'length': IntegerValueValidationModelToJSON(value.length),
        'value': DecimalValueValidationModelToJSON(value.value),
        'date': DateValueValidationModelToJSON(value.date),
    };
}

